/** Watchmode's type values, in the form people actually read. */
export const TYPE_LABELS: Record<string, string> = {
    tv_series: "TV series",
    tv_miniseries: "Mini-series",
    tv_movie: "TV movie",
    tv_special: "TV special",
    short_film: "Short film",
    movie: "Movie",
};

/** Watchmode's source `type`, which is an offering kind rather than a medium. */
export const SOURCE_TYPE_LABELS: Record<string, string> = {
    sub: "Subscription",
    free: "Free",
    buy: "Buy",
    rent: "Rent",
    tve: "Cable login",
};

/**
 * Region codes spelled out. Watchmode returns ISO country codes, and "GB" is
 * not obviously "United Kingdom" to everyone reading a dropdown.
 */
export const REGION_LABELS: Record<string, string> = {
    GB: "UK",
    US: "USA",
    CA: "Canada",
    AU: "Australia",
    IE: "Ireland",
    NZ: "New Zealand",
    IN: "India",
    ZA: "South Africa",
};
